// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Package40FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Package40Filled: FC<Package40FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M18.611 36.375V20.792L5 12.917V26.93c0 .5.123.962.368 1.389.245.425.586.763 1.02 1.013l12.223 7.042Zm2.778 0 12.222-7.042A2.735 2.735 0 0 0 35 26.93V12.89l-13.611 7.903v15.583Zm6.764-22.694 5.333-3.098L21.39 3.625A2.744 2.744 0 0 0 20 3.25c-.49 0-.954.125-1.389.375l-3.986 2.292 13.528 7.764ZM20 18.417l5.347-3.112-13.514-7.777L6.5 10.625 20 18.417Z" />
        </svg>
    );
};

export default Package40Filled;
